import { createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pb-6 px-0 sm:px-6 sm:shadow-sm" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "text-center text-2xl text-gray-800 sm:text-gray-600 font-header mb-8" }, " 2-Step Auth ", -1)
const _hoisted_3 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Alert = _resolveComponent("Alert")
  const _component_Input = _resolveComponent("Input")
  const _component_LoaderIcon = _resolveComponent("LoaderIcon")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.alert.display)
      ? _createVNode(_component_Alert, {
          key: 0,
          type: "error",
          message: _ctx.alert.message
        }, null, 8, ["message"])
      : _createCommentVNode("", true),
    _createVNode(_component_Form, {
      valid: _ctx.isValid,
      "onUpdate:valid": _cache[3] || (_cache[3] = $event => (_ctx.isValid = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Input, {
          autocomplete: "",
          label: "Enter 6 digit code",
          value: _ctx.totp,
          "onUpdate:value": _cache[1] || (_cache[1] = $event => (_ctx.totp = $event)),
          rules: ['required', 'numeric', 'max:6', 'min:6']
        }, null, 8, ["value"]),
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.handleClick())),
          class: ["w-full py-2 rounded flex flex-row items-center justify-center", {
					'bg-secondary shadow-md': _ctx.isValid && !_ctx.disableSubmit,
					'bg-gray-300 text-gray-600': !_ctx.isValid || _ctx.disableSubmit,
				}],
          type: "button",
          disabled: !_ctx.isValid || _ctx.disableSubmit
        }, [
          (_ctx.disableSubmit)
            ? _createVNode(_component_LoaderIcon, {
                key: 0,
                class: "animate-spin -ml-1 mr-3 h-5 w-5 text-gray-600"
              })
            : _createCommentVNode("", true),
          (!_ctx.disableSubmit)
            ? (_openBlock(), _createBlock("span", _hoisted_3, "Verify"))
            : _createCommentVNode("", true)
        ], 10, ["disabled"])
      ]),
      _: 1
    }, 8, ["valid"])
  ]))
}